import React, { useState, useEffect } from "react";
import "../assets/css/Weather.css";
import Header from "../Components/Header";
import WeatherSidebar from "../Components/WeatherSidebar";
import wave from "../assets/images/Wave.svg";
import { TbTemperature, TbDroplet, TbMountain } from "react-icons/tb";
import { LuCloudRain } from "react-icons/lu";
import { MdEdit } from "react-icons/md";
import { getRegionalStates, getZones, getWoredas, getKebeles, addParameter, updateParameter } from "../Services/apiService";

const Weather = () => {
  const [selectedRegionalState, setSelectedRegionalState] = useState("Addis Ababa");
  const [selectedZone, setSelectedZone] = useState("");
  const [selectedWoreda, setSelectedWoreda] = useState("");
  const [selectedKebele, setSelectedKebele] = useState("");
  const [regionalStateData, setRegionalStateData] = useState([]);
  const [zonesForState, setZonesForState] = useState([]);
  const [woredasForZone, setWoredasForZone] = useState([]);
  const [kebelForWoreda, setKebelForWoreda] = useState([]);
  const [localWaterBodies, setLocalWaterBodies] = useState([]);

  const cityData = (() => {
    if (selectedKebele) {
      const kebeleObj = kebelForWoreda.find((k) => k.kebele === selectedKebele);
      if (kebeleObj) return kebeleObj;
    }
    if (selectedWoreda) {
      const woredaObj = woredasForZone.find((w) => w.woreda === selectedWoreda);
      if (woredaObj) return woredaObj;
    }
    if (selectedZone) {
      const zoneObj = zonesForState.find((z) => z.zone === selectedZone);
      if (zoneObj) return zoneObj;
    }
    if (selectedRegionalState) {
      const stateObj = regionalStateData.find(
        (s) => s.regionalState === selectedRegionalState
      );
      if (stateObj) return stateObj;
    }

    return null;
  })();

  useEffect(() => {
    let waterBodies = [];
    switch (true) {
      case !!selectedKebele: {
        const kebeleData = kebelForWoreda.find(
          (k) => k.kebele === selectedKebele
        );
        waterBodies = kebeleData?.parameters?.water_bodies || [];
        break;
      }
      case !!selectedWoreda: {
        const woredaData = woredasForZone.find(
          (w) => w.woreda === selectedWoreda
        );
        waterBodies = woredaData?.parameters?.water_bodies || [];
        break;
      }
      case !!selectedZone: {
        const zoneData = zonesForState.find((z) => z.zone === selectedZone);
        waterBodies = zoneData?.parameters?.water_bodies || [];
        break;
      }
      case !!selectedRegionalState: {
        const stateData = regionalStateData.find(
          (s) => s.regionalState === selectedRegionalState
        );
        waterBodies = stateData?.parameters?.water_bodies || [];
        break;
      }
      default:
        waterBodies = [];
    }
    setLocalWaterBodies(waterBodies);
  }, [selectedRegionalState, selectedZone, selectedWoreda, selectedKebele, zonesForState, regionalStateData, woredasForZone]);

  const [flippedCards, setFlippedCards] = useState([]);
  useEffect(() => {
    setFlippedCards(Array(localWaterBodies.length).fill(false));
  }, [localWaterBodies]);
  const handleCardFlip = (index) => {
    const updated = [...flippedCards];
    updated[index] = !updated[index];
    setFlippedCards(updated);
  };
  const [showModal, setShowModal] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [newWaterBody, setNewWaterBody] = useState({
    name: "",
    waterway: "",
    distance_m: "",
    boat: "",
  });
  const resetModal = () => {
    setNewWaterBody({
      name: "",
      waterway: "",
      distance_m: "",
      boat: "",
    });
    setEditIndex(null);
  };
  const openAddModal = () => {
    resetModal();
    setShowModal(true);
  };
  const [existingFields, setExistingFields] = useState({
    boat: true,
  });
  const openEditModal = (index, item) => {
    setEditIndex(index);

    setNewWaterBody({
      name: item.name || "",
      waterway: item.tags?.waterway || "",
      distance_m: item.distance_m || "",
      boat: item.tags?.boat || "",
      tags: item.tags || {},
    });

    setExistingFields({
      boat: item.tags?.boat !== undefined,
    });

    setShowModal(true);
  };
  const saveWaterbody = async () => {
    let dbName = "";
    let rowId = "";
    if (selectedKebele) {
      dbName = "kebele";
      const kebeleObj = kebelForWoreda.find(
        (s) => s.kebele === selectedKebele
      );
      rowId = kebeleObj._id;

    } else if (selectedWoreda) {
      dbName = "woreda";
      const woredaObj = woredasForZone.find(
        (s) => s.woreda === selectedWoreda
      );
      rowId = woredaObj._id;

    } else if (selectedZone) {
      dbName = "zone";
      const zoneObj = zonesForState.find(
        (s) => s.zone === selectedZone
      );
      rowId = zoneObj._id;
    } else if (selectedRegionalState) {
      dbName = "regional-state";
      const stateObj = regionalStateData.find(
        (s) => s.regionalState === selectedRegionalState
      );
      rowId = stateObj._id;
    }
    if (!dbName || !rowId) {
      console.error("Missing location selection");
      return;
    }
    const cleanTags = (tags = {}) => {
      return {
        name: tags.name || "",
        waterway: tags.waterway || "",
        boat: tags.boat || "",
      };
    };
    const cleanedTags = cleanTags({
      ...newWaterBody.tags,
      name: newWaterBody.name,
      waterway: newWaterBody.waterway,
      boat: newWaterBody.boat,
    });
    const parameter = {
      type: "water_bodies",
      data: {
        name: newWaterBody.name,
        distance_m: Number(newWaterBody.distance_m),
        waterway: newWaterBody.waterway,
        tags: {
          ...newWaterBody.tags,
          name: newWaterBody.name,
          waterway: newWaterBody.waterway,
          boat: newWaterBody.boat,
        },
      }
    };

    const existingparameter = {
      type: "water_bodies",
      data: {
        name: newWaterBody.name,
        distance_m: Number(newWaterBody.distance_m),
        waterway: newWaterBody.waterway,
        tags: cleanedTags,
      }
    };
    try {
      let result;
      if (editIndex !== null && editIndex !== undefined) {
        result = await updateParameter({
          rowId,
          dbName,
          editIndex,
          newParameter: {
            type: "water_bodies",
            data: {
              name: newWaterBody.name,
              distance_m: Number(newWaterBody.distance_m),
              waterway: newWaterBody.waterway,
              tags: cleanedTags
            }
          },
        });
        setLocalWaterBodies(prev => {
          const updated = [...prev];
          updated[editIndex] = {
            ...updated[editIndex],
            ...existingparameter.data,
            tags: {
              ...updated[editIndex].tags,
              ...existingparameter.data.tags
            }
          };
          return updated;
        });
      } else {
        result = await addParameter({
          dbName,
          rowId,
          parameter: parameter
        });
        setLocalWaterBodies(prev => [...prev, result]);
      }
      setShowModal(false);
      resetModal();
    } catch (err) {
      console.error("Save waterbody failed:", err);
    }
  };

  const weatherStats = [
    {
      title: "Temperature",
      value: `${cityData?.parameters?.weather?.temperature_C ?? "--"}°C`,
      subtitle: `Feels like ${cityData?.parameters?.weather?.temperature_C ?? "--"}°C`,
      icon: <TbTemperature className="stats-icon temp-icon" />,
      color: "temp",
    },
    {
      title: "Humidity",
      value: `${cityData?.parameters?.weather?.humidity ?? "--"}%`,
      subtitle: "Relative humidity",
      icon: <TbDroplet className="stats-icon humidity-icon" />,
      color: "humidity",
    },
    {
      title: "Rainfall",
      value: `${Number(cityData?.parameters?.rainfall ?? 0).toFixed(2)}mm`,
      subtitle: "Last 24 hours",
      icon: <LuCloudRain className="stats-icon rain-icon" />,
      color: "rain",
    },
    {
      title: "Elevation",
      value: `${cityData?.parameters?.elevation ?? "--"}m`,
      subtitle: "Current elevation",
      icon: <TbMountain className="stats-icon wind-icon" />,
      color: "elevation",
    },
  ];

  const capitalize = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1) : "";

  useEffect(() => {
    async function fetchStates() {
      try {
        const data = await getRegionalStates();
        setRegionalStateData(data || []);
      } catch (err) {
        console.error("Failed to fetch regional states", err);
        setRegionalStateData([]);
      }
    }
    async function fetchZones() {
      try {
        const data = await getZones();
        setZonesForState(data || []);
      } catch (err) {
        console.error("Failed to fetch zones", err);
        setZonesForState([]);
      }
    }
    async function fetchWoredas() {
      try {
        const data = await getWoredas();
        setWoredasForZone(data || []);
      } catch (err) {
        console.error("Failed to fetch woredas", err);
        setWoredasForZone([]);
      }
    }
    async function fetchKelebes() {
      try {
        const data = await getKebeles();
        setKebelForWoreda(data || []);
      } catch (err) {
        console.error("Failed to fetch kebeles", err);
        setKebelForWoreda([]);
      }
    }
    fetchStates();
    fetchZones();
    fetchWoredas();
    fetchKelebes();
  }, []);

  const getSelectedLocation = () =>
    selectedKebele ||
    selectedWoreda ||
    selectedZone ||
    selectedRegionalState ||
    "Selected Location";

  const isFormValid = () => {
    if (newWaterBody.name.trim() === "") return false;
    if (newWaterBody.waterway.trim() === "") return false;
    if (newWaterBody.distance_m === "") return false;
    if (editIndex === null || existingFields.boat) {
      if (newWaterBody.boat.trim() === "") return false;
    }
    return true;
  };

  return (
    <>
      <Header />
      <div className="weather-wrapper-new">
        <WeatherSidebar
          regionalStateData={regionalStateData}
          zonesForState={zonesForState}
          woredasForZone={woredasForZone}
          kebelForWoreda={kebelForWoreda}
          selectedRegionalState={selectedRegionalState}
          selectedZone={selectedZone}
          selectedWoreda={selectedWoreda}
          selectedKebele={selectedKebele}
          setSelectedRegionalState={setSelectedRegionalState}
          setSelectedZone={setSelectedZone}
          setSelectedWoreda={setSelectedWoreda}
          setSelectedKebele={setSelectedKebele}
        />
        <div className="weather-main-content">
          {showModal && (
            <div className="waterModal-overlay">
              <div className="waterModal-box">
                <h2 className="waterModal-title">
                  {editIndex !== null ? "Edit Waterbody" : "Add Waterbody"}
                </h2>
                <div className="waterModal-field">
                  <label>Name</label>
                  <input
                    type="text"
                    value={newWaterBody.name}
                    onChange={(e) =>
                      setNewWaterBody({ ...newWaterBody, name: e.target.value })
                    }
                  />
                </div>
                <div className="waterModal-field">
                  <label>Waterway Type</label>
                  <input
                    type="text"
                    value={newWaterBody.waterway}
                    onChange={(e) =>
                      setNewWaterBody({
                        ...newWaterBody,
                        waterway: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="waterModal-field">
                  <label>Distance (m)</label>
                  <input
                    type="number"
                    value={newWaterBody.distance_m}
                    onChange={(e) =>
                      setNewWaterBody({
                        ...newWaterBody,
                        distance_m: e.target.value,
                      })
                    }
                  />
                </div>
                {(editIndex === null || existingFields.boat) && (
                  <div className="waterModal-field">
                    <label>Boat Allowed</label>
                    <select
                      value={newWaterBody.boat}
                      onChange={(e) =>
                        setNewWaterBody({
                          ...newWaterBody,
                          boat: e.target.value,
                        })
                      }
                    >
                      <option value="">Select</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                  </div>
                )}
                <div className="waterModal-buttons">
                  <button
                    className="waterModal-cancel"
                    onClick={() => {
                      setShowModal(false);
                      resetModal();
                    }}
                  >
                    Cancel
                  </button>
                  <button className="waterModal-submit" onClick={saveWaterbody} disabled={!isFormValid()}>
                    {editIndex !== null ? "Save Changes" : "Add"}
                  </button>
                </div>
              </div>
            </div>
          )}
          <div className="weatherInfo">
            <div className="section-title">Weather Details</div>
            <div className="weather-flex">
              {weatherStats.map((stat, index) => (
                <div key={index} className={`weather-card-${stat.color}`}>
                  <div className="weather-header">
                    <div className="weather-content">
                      <div className="weather-title">{stat.title}</div>
                      <div className="weather-value">{stat.value}</div>
                      <div className="weather-subtitle">{stat.subtitle}</div>
                    </div>
                    <div className="weather-icon-wrapper">{stat.icon}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="forecast-section">
            <div className="waterbody-header">
              <p className="waterbody-title">
                Information of Water in {getSelectedLocation()}
              </p>

              {(selectedRegionalState || selectedZone || selectedWoreda || selectedKebele) && (
                <button className="add-water-btn" onClick={openAddModal}>
                  + Add Waterbody
                </button>
              )}
            </div>
            {localWaterBodies.length > 0 ? (
              <div className="carousel-wrapper">
                <div className="carousel-container">
                  {localWaterBodies.map((day, index) => (
                    <div key={index} className="forecast-card">
                      <div
                        className={`card-inner ${flippedCards[index] ? "flipped" : ""}`}
                        onClick={() => handleCardFlip(index)}
                      >
                        <div className="card-front">
                          <div className="front-info">
                            <MdEdit
                              className="watercard-icon"
                              onClick={(e) => {
                                e.stopPropagation();
                                openEditModal(index, day);
                              }}
                            />
                            <p>
                              {capitalize(day?.tags?.waterway || day?.tags?.water || "Not Found")}
                            </p>
                            <p>
                              <span>{Number(day?.distance_m ?? 0).toFixed(2)} M</span>
                            </p>
                          </div>
                          <img src={wave} className="waves-front" alt="waves" />
                        </div>

                        <div className="card-back">
                          <div className="back-info">
                            <p>
                              <strong>Name:</strong> {day.name}
                            </p>
                            <p>
                              <strong>Boat:</strong> {day.tags?.boat || "no"}
                            </p>
                          </div>
                          <img src={wave} className="waves-back" alt="waves" />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className="carousel-wrapper">
                <div className="carousel-container">
                  <div className="card-inner">
                    <div className="card-front">
                      <p>No data available</p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Weather;
